import React from "react"
import styled from "styled-components";
import {Bio} from "../../data/constants";
import Typewriter from "typewriter-effect";
import HeroBgAnimation from "../HeroBgAnimation";

const Button = styled.a`
  border: 1.8px solid ${({ theme }) => theme.button};
  color: ${({ theme }) => theme.button};
  background-color: transparent;
  text-decoration: none;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  height: 70%;
  margin-right: 0.5rem;
  display: none;


  :hover {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }

@media (max-width: 768px) {
  
    display: inline-block;
    padding: 10px 20px;
    background-color:  ${({ theme }) => theme.button};
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
  }

  :hover {
    background-color: #0056b3;
  }
}


  @media screen and(max-width : 768px) {
    font-size: 0.8rem;
  }
`;


const HeroConatiner = styled.div`
    background-color : ${({theme})=>theme.card_light};
    display : flex;
    justify-content : center;
    align-items : center;
    position: relative;
    padding: 80px 30px;

    @media (max-width: 960px) {
        padding: 66px 16px;
    }

    @media (max-width: 640) {
        padding: 32px 16px;
    }

    z-index: 1;

    clip-path: polygon(0 0, 100% 0, 100% 100%, 70% 95%, 0 100%);
`;

const HeroBg = styled.div`
    position: absolute;
    display: flex;
    justify-content: end;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 1360px;
    overflow: hidden;
    padding: 0 30px;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);

    @media (max-width: 960px) {
        justify-content: center;
        padding: 0 0px;
    }
`;

export const HeroInnerContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1100px;

    @media (max-width: 960px) {
        flex-direction: column;
    }
`;
export const HeroLeftContainer = styled.div`
    width: 100%;
    order: 1;
    @media (max-width: 960px) {
        order: 2;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media (max-width: 640px) {
        order: 2;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const HeroRightContainer = styled.div`
    width: 100%;
    display: flex;
    order: 2;
    justify-content: end;
    gap: 12px;
    @media (max-width: 960px) {
        order: 1;
        justify-content: center;
        align-items: center;
        margin-bottom: 80px;
    }

    @media (max-width: 640px) {
        margin-bottom: 30px;
    }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 50px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 8px;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 32px;
  display: flex;
  gap: 12px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  @media (max-width: 960px) {
    text-align: center;
  }
  @media (max-width: 640px) {
    font-size: 22px;
    line-height: 48px;
    margin-bottom: 16px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

export const Description = styled.div`
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 42px;
  color: ${({ theme }) => theme.text_primary + 95};

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 32px;
  }
`;


const Img = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 400px;
  max-height: 400px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.primary};

  @media (max-width: 768px) {
    max-width: 400px;
    max-height: 400px;
  }

  @media (max-width: 640px) {
    max-width: 280px;
    max-height: 280px;
  }
`;

const Hero = () => {
    return (
        <div id="about">
            <HeroConatiner>
                <HeroBg>
                    <HeroBgAnimation/>
                </HeroBg>
                <HeroInnerContainer>
                    <HeroLeftContainer>
                        <Title>
                            Hi, I am <br/>{Bio.name}
                        </Title>

                        <TextLoop>
                            I am 
                            <Span> 
                                <Typewriter
                                    options={
                                        {
                                            strings : Bio.roles,
                                            autoStart : true,
                                            loop : true
                                        }
                                    }
                                /> 
                            </Span>
                        </TextLoop>

                        <Description>
                            {Bio.description}
                        </Description>
                         <Button 
            href="https://drive.google.com/file/d/1fQqmyeJEGFSXFeuRcVHpR1gdrvfC94dJ/view?usp=sharing"
            target="blank"
          >
            Download CV
          </Button>

                    </HeroLeftContainer>

                    <HeroRightContainer>
                        <Img></Img>
                    </HeroRightContainer>
                </HeroInnerContainer>
               
            </HeroConatiner>
             
        </div>
    )
}

export default Hero;